<script setup>
import { useAlert } from '@/stores/alert'

const alert = useAlert()
</script>

<template>
  <div
    class="fixed bottom-16 flex justify-center w-full z-20 transition-all transform-gpu translate-y-16"
    :class="{ 'translate-y-0 mb-4': alert.active, hidden: alert.hidden }"
  >
    <div id="toast-default" class="flex items-center p-4 w-full max-w-xs text-gray-800 bg-white rounded-lg shadow" role="alert">
      <div class="ml-3 text-sm font-normal">
        {{ alert.text }}
      </div>
      <button
        type="button"
        class="ml-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex h-8 w-8"
        data-dismiss-target="#toast-default"
        aria-label="Close"
        @click="alert.hide"
      >
        <span class="sr-only"> Close </span>

        <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </button>
    </div>
  </div>
</template>
